import Breadcrumb from 'src/components/v1/Breadcrumb';

interface Props {
  children?: React.ReactNode;
}

export default function ProposalLayout({ children }: Props) {
  return (
    <div className='proposal-layout'>
      <div className='proposal-breadcrumb'>
        <Breadcrumb />
      </div>
      {children}
    </div>
  );
}
